module.exports = __webpack_public_path__ + "static/media/harris-maxwell.6a97b1ab.jpg";